var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.511,
    height: 21.511,
    viewBox: "0 0 21.511 21.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car-svgrepo-com",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34309",
    "data-name": "Path 34309",
    d: "M18.564,10.255l-1-4.266a3.423,3.423,0,0,0-3.213-2.5V3.425A3.429,3.429,0,0,0,10.927,0h-.343A3.429,3.429,0,0,0,7.159,3.425v.064a3.423,3.423,0,0,0-3.212,2.5l-1,4.266A3.136,3.136,0,0,0,0,13.245v2.582a3.074,3.074,0,0,0,2.414,2.9v.85a2.034,2.034,0,0,0,2.115,1.938h.356A2.034,2.034,0,0,0,7,19.573v-.736h7.512v.736a2.034,2.034,0,0,0,2.115,1.938h.357A2.034,2.034,0,0,0,19.1,19.573v-.85a3.074,3.074,0,0,0,2.414-2.9V13.245A3.136,3.136,0,0,0,18.564,10.255ZM10.584.915h.343a2.512,2.512,0,0,1,2.509,2.509v.058H8.074V3.425A2.512,2.512,0,0,1,10.584.915ZM4.838,6.2a2.523,2.523,0,0,1,2.52-1.8h6.8a2.523,2.523,0,0,1,2.52,1.8l.947,4.039H3.89ZM6.084,19.573a1.123,1.123,0,0,1-1.2,1.023H4.529a1.123,1.123,0,0,1-1.2-1.023v-.736H6.084Zm10.9,1.023h-.357a1.123,1.123,0,0,1-1.2-1.023v-.736h2.755v.736A1.123,1.123,0,0,1,16.982,20.6ZM20.6,15.827a2.264,2.264,0,0,1-2.4,2.094H3.313a2.264,2.264,0,0,1-2.4-2.094V13.245a2.264,2.264,0,0,1,2.4-2.094H18.2a2.264,2.264,0,0,1,2.4,2.094Z",
    transform: "translate(-0.5)",
    fill: "#1a214f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34310",
    "data-name": "Path 34310",
    d: "M342.031,290.241a1.9,1.9,0,1,0,2.061,1.891A1.984,1.984,0,0,0,342.031,290.241Zm0,2.866a.988.988,0,1,1,1.146-.975A1.072,1.072,0,0,1,342.031,293.107Z",
    transform: "translate(-325.046 -277.5)",
    fill: "#1a214f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34311",
    "data-name": "Path 34311",
    d: "M58.18,290.241a1.9,1.9,0,1,0,2.061,1.891A1.984,1.984,0,0,0,58.18,290.241Zm0,2.866a.988.988,0,1,1,1.146-.975A1.072,1.072,0,0,1,58.18,293.107Z",
    transform: "translate(-53.655 -277.5)",
    fill: "#1a214f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31968",
    "data-name": "Rectangle 31968",
    width: 4.988,
    height: 0.915,
    transform: "translate(8.261 13.081)",
    fill: "#1a214f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31969",
    "data-name": "Rectangle 31969",
    width: 4.988,
    height: 0.915,
    transform: "translate(8.261 15.267)",
    fill: "#1a214f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.99240d92e3f1b769c5921520f91fb316.svg";
export { ForwardRef as ReactComponent };